import { init } from './MallEEPG';
init();
